<template>
    <div v-if="editor" :ref="refRichText" :class="classes">
        <CompassFormItem
            :label="formitem.label || ''"
            :info="formitem.info"
            :error="formitem.error || ''"
            :disabled="disabled"
            :required="formitem.required"
            :requiredLabel="formitem.requiredLabel"
            :size="formitem.size || 'medium'"
            :tooltip="formitem.tooltip || ''"
        >
            <RichTextBubbleMenu
                v-if="showAIComponents"
                :editorBubbleMenu="editor"
                :options="options"
                :typeRichText="typeRichText"
                :hash="hash"
            />

            <SellsyAILoadingDialog v-if="showAIComponents && showLoader" />

            <editor-content
                :class="editorClass"
                :editor="editor"
                :extensions="editorExtensions"
                :data-ref="refRichText"
                @focus="handleEditorFocus"
                @blur="handleEditorBlur"
            />

            <slot name="drag-handle"></slot>

            <!-- RichTextMenu (Menu with options) -->
            <RichTextMenu
                v-if="showRichTextMenu"
                :editorMenu="editor"
                :options="options"
                :typeRichText="typeRichText"
                :disabled="disabled"
                :hash="hash"
                :attachmentEndpoint="attachmentEndpoint"
            >
                <template #more-custom-options>
                    <slot name="more-custom-options"></slot>
                </template>
                <template #actions>
                    <slot name="actions"></slot>
                </template>
                <template #more-block>
                    <slot name="more-block"></slot>
                </template>
            </RichTextMenu>
        </CompassFormItem>
    </div>
</template>

<script>
import RichTextMixin from 'mixins/RichTextMixin';
import RichTextMenu from './RichTextMenu.vue';
import RichTextBubbleMenu from './RichTextBubbleMenu.vue';
import SellsyAILoadingDialog from 'vcomponents/richtext/SellsyAILoadingDialog.vue';
import Feature from 'Services/Feature';

export default {
    name: 'RichText',
    components: {
        RichTextMenu,
        RichTextBubbleMenu,
        SellsyAILoadingDialog,
    },
    mixins: [RichTextMixin],
    props: {
        value: {
            type: String,
            default: '',
        },
        refRichText: {
            type: String,
            default: '',
        },
        formitem: {
            type: Object,
            default: () => ({}),
        },
        isCustom: {
            type: Boolean,
            default: false,
        },
        showRichTextMenu: {
            type: Boolean,
            default: true,
        },
        showAIComponents: {
            type: Boolean,
            default: false,
        },
        typeRichText: {
            type: String,
            default: '',
        },
        hash: {
            type: String,
            default: '',
        },
        attachmentEndpoint: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            isFocus: false,
        };
    },
    computed: {
        /* custom class */
        classes() {
            return [
                { 'rich-text': !this.isCustom },
                { 'is-disabled': this.disabled },
                { 'is-focus': this.isFocus },
                { 'is-error': this.formitem.error && !this.disabled },
            ];
        },
        getHash() {
            return `ai-${this.hash}`;
        },
        showLoader() {
            return this.$store.state[this.getHash]?.showLoader || false;
        },
        editorClass() {
            return Feature.isEnabled('email-engine') ? 'has-margins' : '';
        },
    },
    watch: {
        value(value) {
            const isSame = this.editor.getHTML() === value;
            if (isSame) {
                return;
            }
            this.editor.commands.setContent(value, false);
        },
        isFocus(value) {
            if (value) {
                this.$emit('focus');
            } else {
                this.$emit('blur');
            }
        },
    },
    methods: {
        handleEditorFocus() {
            this.isFocus = true;
        },
        handleEditorBlur() {
            this.isFocus = false;
        },
    },
};
</script>
